export enum Fields {
  NAME = 'name',
  FORM = 'organization_form',
}
